export * from '@primeuix/themes/aura/treeselect';
export { default } from '@primeuix/themes/aura/treeselect';
